import styled from 'styled-components';
import MOText from 'common/components/atoms/MOText';
import MOMainButton from 'common/components/atoms/MOMainButton';
import { ReactComponent as CrossIcon } from 'assets/images/cross-icon.svg';
import { BREAKPOINTS } from 'common/styles';

const StyledBox = styled.div`
  position: relative;
  background: #fff;
  max-width: 550px;
  width: 100%;
  padding: 16px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);

  &.squished {
    max-width: 750px;
    padding: 16px 20px 24px;
  }
`;

const StyledText = styled(MOText)`
  padding-right: 28px;
`;

const StyledCloseBtn = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
`;

const ButtonBox = styled.div`
  display: flex;
  gap: 16px;

  &.squished {
    justify-content: flex-end;
  }

  @media only screen and (max-width: ${BREAKPOINTS.SMALL}px) {
    flex-direction: column;
  }
`;

export interface IPopup {
  title: string,
  actionText?: string,
  dismissText?: string,
  className?: 'default' | 'squished',
  actionBtnStyle?: 'primary' | 'alert',
  variant?: 'default' | 'no-dismiss',
  disabled?: boolean,
  onAction?: any,
  onDismiss?: () => void,
  children?: React.ReactNode,
  hideCancel?: boolean,
  hideAction?: boolean,
}

const Popup:React.FC<IPopup> = ({
  title,
  actionBtnStyle = 'primary',
  actionText = 'Accept',
  dismissText = 'Cancel',
  variant = 'default',
  className = 'default',
  disabled = false,
  onDismiss = () => null,
  onAction = () => null,
  children,
  hideCancel = false,
  hideAction = false,
}) => (
  <StyledBox className={className}>
    {variant !== 'no-dismiss' && (
      <StyledCloseBtn onClick={onDismiss}>
        <CrossIcon />
      </StyledCloseBtn>
    )}
    <StyledText as="h4" typographyStyle="heading4">{title}</StyledText>
    {children}
    <ButtonBox className={className}>
      {(variant !== 'no-dismiss' && !hideCancel) && (
        <MOMainButton
          text={dismissText}
          width={className !== 'squished' ? '100%' : undefined}
          buttonStyle="secondary"
          onClick={onDismiss}
        />
      )}
      {!hideAction && (
        <MOMainButton
          text={actionText}
          width={className !== 'squished' ? '100%' : undefined}
          buttonStyle={actionBtnStyle}
          onClick={onAction}
          disabled={disabled}
        />
      )}
    </ButtonBox>
  </StyledBox>
)

export default Popup;
